module.exports = __webpack_public_path__ + "img/917-f2eec4.png";